"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.declineReasons = void 0;
exports.declineReasons = {
    unapply: [
        'No longer interested',
        'No longer available for these dates',
        'Personal reasons',
        'Do not want to work at this facility',
        'Do not want to work in this city',
        'Have a schedule conflict',
        'Accepted another job/assignment',
        'Cannot travel at this time',
        'Assignment details changed',
        'Applied by mistake',
        'Other',
    ],
    decline: [
        'No longer available for these dates',
        'Do not want to work in this city',
        'Do not want to work at this facility',
        'Have a schedule conflict',
        'Accepted another job/assignment',
        'Cannot travel at this time',
        'Schedule changed & cannot work this',
        'Unable to secure housing',
        'Personal reasons',
        'Other',
    ],
    cancel_interview: [
        'Accepted another offer with Medely',
        'Accepted another offer outside of Medely',
        'Not able to travel at this time',
        'No longer available for these dates',
        "Do not want to work in this city",
        "Do not want to work at this facility",
        'Have a schedule conflict',
        'Schedule changed & cannot work this',
        'Personal reasons',
        'Other',
    ],
};
